import React from "react";
import { ContactInformationGroup } from "./ContactInformationGroup";
import { AddressGroup } from "@/checkout/Sections/CustomerSection/AddressGroup";
type CustomerSectionProps = {
  isPending: boolean;
  hideBirthdateFields?: boolean;
};
export const CustomerSection = ({
  isPending,
  hideBirthdateFields,
}: CustomerSectionProps) => {
  return (
    <>
      <ContactInformationGroup isDisabled={isPending} />
      <AddressGroup
        hideBirthdateFields={hideBirthdateFields}
        isDisabled={isPending}
      />
    </>
  );
};
